import React, {useRef, CSSProperties, ReactElement} from 'react';
import { Input, Row, Col, DatePicker } from 'antd';
import moment from 'moment';
import {InputProps} from "antd/lib/input";
import {DatePickerProps} from "antd/lib/date-picker/interface";

export interface CredentialInputProps {
    showKey?: boolean,
    showExpiration?: boolean,
    inputProps?: any,
    disabled?: boolean,
    style?: CSSProperties,
    value?: any,
    extra?: React.ReactNode[],
    onChange?(value: any): void,
    renderKey?: (inputElement: ReactElement<InputProps>) => React.ReactNode,
    renderExpiration?: (inputElement: ReactElement<DatePickerProps>) => React.ReactNode,
}

export const CredentialInput: React.FC<CredentialInputProps> = ({
    value={},
    onChange=() => null,
    showKey=true,
    showExpiration=true,
    inputProps={},
    disabled=false,
    renderKey = (e) => e,
    renderExpiration = (e) => e,
    extra=[],
    style
}) => {
    const keyInput = useRef(null);
    const expInput = useRef(null);
    const inputStyle = inputProps.style || {};

    const onInputChange = (type, getValue=(e) => e.target.value) =>  (e) => {
        onChange({
            ...value,
            [type]: getValue(e)
        })
    }

    const renderInput = (title, render) => {
        return (
            <Row type="flex" gutter={12}>
                <Col span={6} style={{ textAlign: 'right' }}>
                    {title}
                </Col>
                <Col span={18}>
                    {render}
                </Col>
            </Row>
        )
    }

    return (
        <Row type="flex" style={style}>
            {showKey ? (
                <Col style={{ flex: 1 }}>
                    {renderInput('Key', (
                        renderKey(
                            <Input
                                disabled={disabled}
                                {...inputProps}
                                style={{ width: 'auto', ...inputStyle }}
                                ref={keyInput}
                                value={value.key}
                                onChange={onInputChange('key')}
                            />
                        )
                    ))}
                </Col>
            ) : null}
            {showExpiration ? (
                <Col style={{ flex: 1 }}>
                    {renderInput('Expiration', (
                        renderKey(
                            <DatePicker
                                disabled={disabled}
                                {...inputProps}
                                style={{ width: 'auto', ...inputStyle }}
                                ref={expInput}
                                value={value.expiration && moment(value.expiration)}
                                onChange={onInputChange('expiration', (value) => value && value.format('YYYY-MM-DD'))}
                                format="MM-DD-YYYY"
                            />
                        )
                    ))}
                </Col>
            ) : null}
            {extra?.map((item) => {
                return <Col style={{ flex: 1 }}>
                    {item}
                </Col>
            })}
        </Row>
    )
}